<div class="origination-fees-container">
  <form #originationFeesForm="ngForm" class="origination-fees-form">
    <div class="section-header mb-3">
      <h5>Origination Fees (Section A)</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Application Fee</label>
        <currency-input
          [(ngModel)]="formData.applicationFee"
          name="applicationFee"
          [allowEmpty]="true">
        </currency-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Loan Origination Fee</label>
        <currency-input
          [(ngModel)]="formData.loanOriginationFee"
          name="loanOriginationFee"
          [allowEmpty]="true"
          [readonly]="true">
        </currency-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Discount Point Fee</label>
        <currency-input
          [(ngModel)]="formData.discountPointFee"
          name="discountPointFee"
          [allowEmpty]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Underwriter Fee</label>
        <currency-input
          [(ngModel)]="formData.underwriterFee"
          name="underwriterFee"
          [allowEmpty]="true">
        </currency-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Processor Fee</label>
        <currency-input
          [(ngModel)]="formData.processorFee"
          name="processorFee"
          [allowEmpty]="true">
        </currency-input>
      </div>
    </div>

    <!-- Dynamic Fees Section -->
      <div class="dynamic-fees-section mt-4">
        <div class="section-header mb-3">
          <h6>Additional Origination Fees</h6>
        </div>
        @if (formData.dynamicFees.length > 0) {
          <div class="row mb-2">
            <div class="col-md-6"><strong>Fee Name</strong></div>
            <div class="col-md-5"><strong>Amount ($)</strong></div>
            <div class="col-md-1"></div>
          </div>
        }

        @for (fee of formData.dynamicFees; track fee.uuid; let i = $index) {
          <div class="row mb-2">
            <div class="col-md-6">
              <input type="text" class="form-control" [(ngModel)]="fee.name"
                     [name]="'dynamicFeeName_' + i"
                     placeholder="Fee name">
            </div>
            <div class="col-md-5">
              <currency-input [(ngModel)]="fee.amount" [name]="'dynamicFeeAmount_' + i"
                              [allowEmpty]="true">
              </currency-input>
            </div>
            <div class="col-md-1">
              <button type="button" class="btn btn-sm btn-danger"
                      (click)="removeDynamicFee(i)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </div>
        }

        <button type="button" class="btn btn-sm btn-primary mt-2"
                (click)="addDynamicFee()">
          <i class="pi pi-plus"></i> Add Fee
        </button>
      </div>
  </form>
</div>
